// Dependencias
import { Modal } from 'bootstrap';
import DataTable, { Api } from 'datatables.net-bs5';

// Utils
import { loadLoader } from '../utils/loader';
import {
  drawAcctionButonElement,
  drawShowMoreButton,
  drawTable,
  drawStatusElement,
  formatPhoneNumber
} from '../utils/drawTable';
import { validInputStyle, ValidationsTypes } from '../utils/stylesInputs';

// Servicios
import * as clientService from '../service/client.service';

// Configuraciones
import { generalConfig } from '../config/datatable.config';

// Elementos HTML
const usersCheckTableElement =
  document.querySelector<HTMLTableElement>('#usersCheck')!;
const formCheckUserFilterElement = document.querySelector<HTMLFormElement>(
  '#form-checkUser-filter'
)!;
const typeStatusClientElement = document.querySelector<HTMLSelectElement>(
  '#type-status-client'
)!;
const selectSearchElement =
  document.querySelector<HTMLSelectElement>('#selectSearch')!;
const inputSearchElement =
  document.querySelector<HTMLInputElement>('#inputSearch')!;

// Variables Globales
let userCheckTable: Api<string[]>;
let currentPage = 1;
let lengthTable = 10;
const eventsInputsToValid = ['keyup', 'change', 'focusout'];

export function main() {
  document.addEventListener('DOMContentLoaded', () => {
    // Modal de motivo de rechazo (funciona con event delegation: SSR y filas dinámicas)
    const rejectionModal = document.getElementById('rejectionReasonModal')!;
    const rejectionBody = document.getElementById('rejectionReasonBody')!;
    rejectionModal.addEventListener('show.bs.modal', (event) => {
      const btn = (event as any).relatedTarget as HTMLElement;
      rejectionBody.textContent = btn?.getAttribute('data-rejection-reason') ?? '';
    });

    userCheckTable = new DataTable(usersCheckTableElement, generalConfig);

    userCheckTable.on('draw', async() => {
      const info = userCheckTable.page.info();

      // Si la Pagina no es mayor a los datos establecidos, sale de la función
      if (!(info.page + 1 > currentPage)) return;

      // Optención de Datos de filtro
      const json = Object.fromEntries(
        new FormData(formCheckUserFilterElement)
      ) as ParamsSearch;

      const { status, ...rest } = json;
      const params: { [key: string]: string } = status === TypeInputOptions.ALL || !status ? {} : { status };
      if (rest.selectSearch && rest.valueToSearch)
        params[rest.selectSearch!] = rest.valueToSearch;
      currentPage = info.page + 1;

      // Carga de datos en todos
      loadLoader({});
      const listOfCheckClients = await clientService.searchCheckClientBy({
        params,
        page: currentPage + 1,
        limit: lengthTable
      });
      drawTable<clientService.CheckClient[]>({
        data: listOfCheckClients,
        table: userCheckTable,
        addFinale: true,
        format: formtData
      });
      loadLoader({ start: false });
    });

    userCheckTable.on('length', async(_, __, len) =>  {
      lengthTable = len;

      // Optención de Datos de filtro
      const json = Object.fromEntries(
        new FormData(formCheckUserFilterElement)
      ) as ParamsSearch;

      const { status, ...rest } = json;
      const params: { [key: string]: string } = status === TypeInputOptions.ALL || !status ? {} : { status };
      if (rest.selectSearch && rest.valueToSearch)
        params[rest.selectSearch!] = rest.valueToSearch;

      // Carga de datos en todos
      loadLoader({});
      const listOfCheckClients = await clientService.searchCheckClientBy({
        params,
        limit: lengthTable * 2
      });
      drawTable<clientService.CheckClient[]>({
        data: listOfCheckClients,
        table: userCheckTable,
        format: formtData
      });
      currentPage = 1;
      loadLoader({ start: false });
    });
  });

  typeStatusClientElement.addEventListener('change', async() => {
    const inputsFilters = [
      ...formCheckUserFilterElement.querySelectorAll('.filter-input')
    ] as [HTMLSelectElement, HTMLInputElement];
    // Los filtros de búsqueda siempre están habilitados, independientemente del estatus seleccionado
    inputsFilters.forEach((element) => (element.disabled = false));
  });

  // Validaciones de estilos en los inputs de los filtros
  [selectSearchElement, inputSearchElement, typeStatusClientElement].forEach(
    (element) =>
      eventsInputsToValid.forEach((event) =>
        element.addEventListener(event, (e) => {
          // Optencion de los elementos del input
          const target = e.target as HTMLSelectElement | HTMLInputElement;
          const container = target.parentElement as HTMLDivElement;
          const input = target;

          const isEmpty = target.value.length <= 0;
          if (isEmpty) {
            return validInputStyle({
              type: ValidationsTypes.RESET,
              container,
              input
            });
          }

          return validInputStyle({
            type: ValidationsTypes.VALID,
            container,
            input
          });
        })
      )
  );

  formCheckUserFilterElement.addEventListener('submit', async(e) => {
    e.preventDefault();

    // Se optiene la información del formulario
    const target = e.target as HTMLFormElement;
    const json = Object.fromEntries(new FormData(target)) as ParamsSearch;

    const { status, ...rest } = json;
    const params: { [key: string]: string } =
      status === TypeInputOptions.ALL ? {} : { status };
    if (rest.selectSearch && rest.valueToSearch)
      params[rest.selectSearch!] = rest.valueToSearch;

    loadLoader({});
    const listOfCheckClients = await clientService.searchCheckClientBy({
      params,
      limit: 20
    });
    drawTable({
      data: listOfCheckClients,
      table: userCheckTable,
      format: formtData
    });
    loadLoader({ start: false });
    currentPage = 1;
  });
}

/**
 *
 * @param data
 * @returns
 */
const formtData = (data: clientService.CheckClient[]) =>
  data.map((client) => {
    const {
      id,
      name,
      lastname,
      email,
      phone,
      status,
      verificadoPor,
      rejectionReason,
      rechazadoPor,
      ..._
    } = client;

    const [phoneFormat, statusFormat] = [
      formatPhoneNumber(phone),
      (() => {
        switch (status) {
          case clientService.StatusUsers.PENDIENTE:
            return `
              <span class="badge rounded-pill bg-warning fs-6">
                ${clientService.StatusUsers.PENDIENTE} <i class="bi bi-person-fill-exclamation"></i>
              </span>
            `;
          case clientService.StatusUsers.SIN_VERIFICAR:
            return drawStatusElement(clientService.StatusUsers.SIN_VERIFICAR);
          case clientService.StatusUsers.VERIFICADO:
            return drawStatusElement(clientService.StatusUsers.VERIFICADO);
        }
        return 'N/A';
      })()
    ];

    return [
      `${id}`,
      `${name} ${lastname}`,
      email,
      phoneFormat,
      statusFormat,
      verificadoPor === null ? 'N/A' : `${verificadoPor}`,
      rechazadoPor === null ? 'N/A' : `${rechazadoPor}`,
      rejectionReason === 'N/A'
        ? rejectionReason
        : drawShowMoreButton(rejectionReason!),
      drawAcctionButonElement(id)
    ];
  });

// Definicion de tipos e interfaces
type ParamsSearch = {
  status: string;
  selectSearch?: string;
  valueToSearch?: string;
};
enum TypeInputOptions {
  ALL = 'all',
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'phone',
  VERIFIY = 'select',
}
